export default __webpack_public_path__ + "static/media/6.ca7e7644.webp";